<!-- =========================================================================================
    File Name: TechnicAddNew.vue
    Description: Add new technic component
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div data-backdrop="static" id="technicAddNew" class="xbig ybig">
    <vs-prompt
      name="serviskaydi"
      vs-title="Teknik Servis Kaydı"
      vs-accept-text="Oluştur"
      vs-cancel-text="Vazgeç"
      vs-button-cancel="border"
      @vs-cancel="cancel"
      @vs-accept="submitRegistiration"
      @vs-close="cancel"
      :vs-is-valid="validateFormService"
      :vs-active.sync="addNewRegister"
    >
      <div>
        <div class="vx-row mb-3 flex">
          <div class="vx-col w-1/4 text-right">
            <vs-button color="danger" type="filled" @click="addNewCustomer">Müşteri Ekle</vs-button>
          </div>
          <div class="vx-col w-1/2 flex">
            <vs-input name="musteriAd" icon-pack="feather" icon="icon-user" placeholder="Ara.." class="w-full" v-model="searchQuery" :color="validateFormService ? 'success' : 'danger'" @keyup="delayedSearch" />

            <vs-button type="border" class="ml-5" @click="search()">Ara</vs-button>
          </div>
          <div class="vx-col w-1/4 flex"></div>
        </div>

        <div class="vx-row" id="tblSearchResultsContainer">
          <div class="vx-col w-full">
            <vs-table noDataText="Tabloda Veri Yok" :data="customerSearch">
              <template slot="thead">
                <vs-th hidden>id</vs-th>
                <vs-th class="w-1/3">Müşteri</vs-th>
                <vs-th class="w-1/6">Telefon</vs-th>
                <vs-th class="w-3/6">Adres</vs-th>
                <vs-th class="w-1/12">Seç</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="data[i].userId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td hidden :data="data[i].userId" class="pt-0 pb-1">{{ data[i].userId }}</vs-td>

                  <vs-td :data="data[i].firstName + ' ' + (data[i].lastName == null ? '' : data[i].lastName)" class="pt-0 pb-1">{{ data[i].firstName + " " + (data[i].lastName == null ? "" : data[i].lastName) }}</vs-td>

                  <vs-td :data="data[i].phone" class="pt-0 pb-1">
                    {{ data[i].phone }}
                  </vs-td>

                  <vs-td :data="data[i].address" class="pt-0 pb-1">
                    {{ data[i].address }}
                  </vs-td>

                  <vs-td class="pt-0 pb-1" style>
                    <vs-button type="border" size="small" icon-pack="feather" icon="icon-check-square" color="success" @click="selectItem(i)"></vs-button>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
      <!-- teknik cihaz kabul işlemler-->
      <div v-if="!garageComes">
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <vs-input disabled size="small" name="musteriAdSoyad" class="w-full mb-0 mt-5" placeholder="Müşteri Adı Soyadı" v-model="selectedCustomer.firstName" />
          </div>
          <div class="vx-col w-1/2">
            <vs-input disabled size="small" name="musteriTelefon" class="w-full mb-0 mt-5" placeholder="Müşteri Telefonu" v-model="selectedCustomer.phone" :color="validateFormService ? 'success' : 'danger'" />
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-1/2">
            <vs-input v-validate="'required'" size="small" name="deviceCurrierName" class="w-full mb-0 mt-5" placeholder="Cihazı Getiren Ad Soyad" v-model="orderCreatingProperties.deliveredBy" :color="validateFormService ? 'success' : 'danger'" />
          </div>
          <div class="vx-col w-1/2">
            <v-select class="w-full mb-0 mt-5" v-validate="'required'" name="serviceStatusSeleciton" placeholder="Servis Türü" :options="serviceStatus" v-model="currentServiceType" label="value">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-1/2">
            <input :disabled="!isAdmin()" class="w-full mb-2 mt-5" type="datetime-local" v-model="orderCreatingProperties.recordDate" name="arrangementDate" @change="isValid($event, '', 'red')" />

            <!-- <flat-pickr
              :config="configdateTimePicker"
              name="serviceRegisterDate"
              class="w-full mb-0 mt-5"
              placeholder="Servis Kayıt Tarihi"
              :disabled="!isAdmin()"
              :value="orderCreatingProperties.recordDate"
            /> -->
          </div>
          <div class="vx-col w-1/2">
            <vs-button class="w-full mb-0 mt-5" type="border" size="small" name="activeDeviceFeatures" @click="openDeviceSelectionPopup">Cihaz Seçimi</vs-button>
          </div>
          <!-- Teknik Servise gelen Cihaz Seçimi -->
          <vs-popup title="Teknik Servis Cihaz Seçimi" :active.sync="activeDeviceFeatures">
            <div class="vx-row">
              <div class="vx-col w-1/2">
                <input id="rdbBarcode" type="radio" class="radio-button" name="technicGroup" @click="barcodeProductSelection = true" checked />
                <label for="rdbBarcode">
                  <b>Satın alınmış cihaz ekle</b>
                </label>
              </div>
              <div class="vx-col w-1/2">
                <input id="rdbNoBarcode" type="radio" class="radio-button" name="technicGroup" @click="barcodeProductSelection = false" />

                <label for="rdbNoBarcode">
                  <b>Olmayan bir ürün ekle</b>
                </label>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-1/2">
                <v-select v-model="currentDeviceBarcode" :options="ownedDevices" name="currentDeviceBarcode" menu-props="auto" label="label" :disabled="!barcodeProductSelection" class="w-full mb-4 mt-5">
                  <template slot="option" slot-scope="option">
                    <span :title="option.label">{{ option.label.substr(0, 30) }}</span>
                  </template>
                  <span slot="no-options">Bu müşteri hiç cihaz almamış</span>
                </v-select>
              </div>

              <div class="vx-col w-1/2">
                <vs-input name="deviceBrand" class="w-full mb-4 mt-5" placeholder="Cihaz Markası" size="small" :disabled="barcodeProductSelection" v-model="currentProductBrand" />
                <vs-input name="deviceModel" class="w-full mt-5" placeholder="Cihaz Modeli" size="small" :disabled="barcodeProductSelection" v-model="currentProductModel" />
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-3/4"></div>
              <div class="vx-col w-1/4 mt-5 mb-5">
                <vs-button type="filled" size="small" @click="addDeviceToSelectionTable">Ekle</vs-button>
              </div>
            </div>

            <hr />

            <div id="heighter" class="mt-1">
              <vs-table noDataText="Tabloda Veri Yok" :data="productSelection">
                <template slot="thead">
                  <vs-th>Ürün</vs-th>
                  <vs-th>Seri No</vs-th>
                  <vs-th>Sil</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="i" v-for="(tr, i) in data">
                    <vs-td hidden :data="data[i].productId">{{ data[i].productId }}</vs-td>

                    <vs-td width="65%" :data="data[i].productName">{{ data[i].productName }}</vs-td>

                    <vs-td :data="data[i].barcode">{{ data[i].barcode }}</vs-td>

                    <vs-td width="10%">
                      <vs-button type="border" size="small" icon-pack="feather" icon="icon-trash" color="danger" @click.stop="deleteRow(i)"></vs-button>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>

              <div class="vx-row mb-3" id="multipleImage" style="display: flex; justify-content: center">
                <vue-upload-multiple-image
                  @upload-success="uploadImageSuccess"
                  @before-remove="beforeRemove"
                  @edit-image="editImage"
                  :data-images="imageList"
                  idUpload="myIdUpload"
                  editUpload="myIdEdit"
                  dragText="Resim Yükle"
                  browseText="Seçmek için tıkla"
                  primaryText="Kapak Foto"
                  markIsPrimaryText="Kapak Yap"
                  popupText="resim bilgisi"
                  dropText="Bırak"
                  style="
                    width: 500px;
                    justify-content: center;
                    margin-left: 20px;
                  "
                ></vue-upload-multiple-image>
              </div>
            </div>
            <div class="vx-row mt-3">
              <div class="vx-col w-1/2"></div>
              <div class="vx-col w-1/4">
                <vs-button type="filled" @click="submitDeviceFeatures">Kaydet</vs-button>
              </div>
              <div class="vx-col w-1/4">
                <vs-button type="border" color="warning" @click="cancelDeviceFeatures">Vazgeç</vs-button>
              </div>
            </div>
          </vs-popup>
          <!-- !Teknik Servise gelen Cihaz Seçimi -->
        </div>

        <div class="vx-row">
          <div class="vx-col w-1/2">
            <vs-textarea
              v-validate="'required'"
              label="Cihaz Aksesuar"
              name="accesories"
              class="w-full mb-0 mt-5"
              placeholder="Müşterinin cihazla beraber getirdiği aksesuarlar"
              v-model="orderCreatingProperties.accesories"
              :color="validateFormService ? 'success' : 'danger'"
            />
          </div>
          <div class="vx-col w-1/2">
            <vs-textarea
              v-validate="'required'"
              label="Müşterinin cihazdan şikayeti"
              name="customerNote"
              class="w-full mb-0 mt-5"
              placeholder="Müşteri Şikayeti"
              v-model="orderCreatingProperties.customerNote"
              :color="validateFormService ? 'success' : 'danger'"
            />
          </div>
        </div>
      </div>
      <!-- !teknik cihaz kabul işlemler--->
    </vs-prompt>
    <add-new-customer :addnew="addNewCust" v-if="addNewCust" :withAdditionalData="false" @hideAddNewRegister="hideAddNewCust"></add-new-customer>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";
import "flatpickr/dist/flatpickr.css";
import { repository } from "@/_services/repository.js";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import { Validator } from "vee-validate";
import addNewCustomer from "../contacts/addNewPrompt.vue";

const dict = {
  custom: {
    modelYear: {
      numeric: "Lütfen sayı giriniz",
    },
    vehiclePlate: {
      required: "Araç plakası zorunludur!",
    },
    vehicleCat: {
      required: "Araç Kategorisi zorunludur!",
    },
    engineNo: {
      required: "Araç Motor No zorunludur!",
    },
    vin: {
      required: "Araç VIN zorunludur!",
    },
    mileage: {
      required: "Araç KM zorunludur!",
      numeric: "Lütfen sayı giriniz",
    },
    engineCapacity: {
      numeric: "Lütfen sayı giriniz",
    },
    horsePower: {
      numeric: "Lütfen sayı giriniz",
    },
  },
};
Validator.localize("tr", dict);

export default {
  components: {
    flatPickr,
    vSelect,
    VueUploadMultipleImage,
    addNewCustomer,
  },
  props: {
    addnew: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      fuelType: [
        { text: "Dizel", value: "dizel" },
        { text: "Benzin", value: "benzin" },
        { text: "Lpg", value: "lpg" },
      ],
      currentServiceType: "",
      ownedDevices: [],
      addNewCust: false,
      delayedSearchTimer: null,
      vehicleDropDowns: [],
      garageComes: false,
      currentDeviceBarcode: null,
      currentProductBrand: "",
      currentProductModel: "",
      barcodelessDevices: [],
      customerSearch: [],
      searchQuery: "",
      cat: null,
      brand: null,
      barcodeProductSelection: true,
      serviceStatus: [],
      selectedCustomer: {},
      productSelection: [],
      imageList: [],

      orderCreatingProperties: {},

      configdateTimePicker: {
        enableTime: true,
        dateFormat: "Y-m-d H:i",
      },
      activeDeviceFeatures: false,
    };
  },
  computed: {
    getDate() {
      let d = new Date();
      d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
      return d.toISOString().substr(0, 16);
    },

    addNewRegister: {
      get() {
        return this.addnew;
      },
      set() {},
    },
    validateFormService() {
      return this.productSelection.length > 0 && this.orderCreatingProperties.customerId != 0 && this.currentServiceType != "" && this.orderCreatingProperties.deliveredBy != "" && this.orderCreatingProperties.customerNote != "";
    },
  },
  watch: {
    garageComes: function() {
      if (this.garageComes == true) this.orderCreatingProperties.serviceType = 4;
      else this.orderCreatingProperties.serviceType = 0;
    },
  },
  methods: {
    isValid(event, success, fail) {
      if (event instanceof Event) {
        if (event["target"] && event.target instanceof HTMLInputElement) {
          let e = document.getElementsByName(event.target.name);
          if (this.isDateTime(event)) {
            if (e && e[0]) {
              e[0].style["color"] = success;
            }
          } else {
            if (e && e[0]) e[0].style["color"] = fail;
          }
        }
      }
      return false;
    },
    isDateTime(d) {
      if (d instanceof Date) {
        return !isNaN(d);
      }
      if (typeof d === "string") {
        return this.isDateTime(new Date(d));
      }
      if (d instanceof Event) {
        if (d["target"] && d.target instanceof HTMLInputElement) return this.isDateTime(new Date(d.target.value));
      }
    },
    delayedSearch() {
      if (this.delayedSearchTimer) {
        clearTimeout(this.delayedSearchTimer);
        this.delayedSearchTimer = null;
      }
      this.delayedSearchTimer = setTimeout(() => {
        if (this.searchQuery && this.searchQuery.length > 3) this.search();
      }, 500);
    },
    //müşteriler sayfasından ekleme paneli
    addNewCustomer() {
      this.addNewCust = true;
    },
    hideAddNewCust() {
      this.addNewCust = false;
    },
    //başlangıcta veri içeriğini belirlemek için kullandık lifecycleda bir problemden ötürü
    initProp() {
      this.orderCreatingProperties = {
        userId: 0,
        serviceType: 0,
        customerId: 0,
        deliveredBy: "",
        customerNote: "",
        DbOrderLineType: [],
        orderTotal: 0,
        accesories: "",
        orderdiscount: 0,
        recordDate: "",
        deliveryDate: "",
        barcodelessTable: [],
        vehicle: {
          id: 0,
          plate: "",
          fuel: "",
          model: "",
          vin: "",
          engineNo: "",
          mileage: "",
          engineCapacity: "",
          horsePower: "",
          documentNumber: "",
          modelYear: "",
        },
      };
      return this.orderCreatingProperties;
    },
    //garaj girişinde araçların kategori ve marka seçimine göre model seçilimi
    carSelection() {
      if (this.cat != null && this.brand != null) {
        return true;
      } else return false;
    },
    openDeviceSelectionPopup: async function() {
      if (!this.activeDeviceFeatures) {
        await this.getCustomerProducts();
        this.activeDeviceFeatures = true;
      } else {
        this.$vs.notify({
          title: "Hata!!!!",
          text: "Veriler yüklenene kadar lütfen bekleyiniz...",
          color: "primary",
        });
      }
    },
    //uploader methods
    uploadImageSuccess(formData, index, fileList) {
      this.imageList = fileList;
    },
    beforeRemove(index, done, fileList) {
      console.warn(fileList);
      done();
    },
    editImage(formData, index, fileList) {
      console.warn(fileList);
    },
    //müşteri arama sonucu listelenen kişilerden seçim yapılması
    selectItem(i) {
      if (!this.customerSearch[i].isReadyForInvoice) {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: this.customerSearch[i].error,
        });
        return;
      }
      this.selectedCustomer = JSON.parse(JSON.stringify(this.customerSearch[i]));
      if (this.selectedCustomer.lastName != null) {
        this.selectedCustomer.firstName = this.selectedCustomer.firstName + " " + this.selectedCustomer.lastName;
      }
      this.orderCreatingProperties.customerId = this.selectedCustomer.customerId;
    },

    //müşteri arama
    search: async function() {
      this.customerSearch = await repository.getWithParam("Customer/search", "searchQuery=" + this.searchQuery).then((r) => r.list);
      if (this.customerSearch.length == 0) {
        this.$vs.notify({
          title: "Hata",
          text: "Böyle bir müşteri bulunamadı!",
          color: "danger",
        });
      }
      if (this.customerSearch && this.customerSearch.length == 1) this.selectItem(0);
      return this.customerSearch;
    },
    isAdmin() {
      return this.$store.state.userData.role === "Admin";
    },
    //teknik servis cihaz seçimi yapıldıktan sonra kayıt için verilerin uygun şekile getirlimesi
    addDeviceToSelectionTable() {
      if (this.barcodeProductSelection && this.currentDeviceBarcode != null) {
        this.productSelection.push({
          productId: this.currentDeviceBarcode.productId,
          productType: 1,
          productName: this.currentDeviceBarcode.product,
          barcode: this.currentDeviceBarcode.serialNumber,
          barcodeId: this.currentDeviceBarcode.serialNumberId,
        });
      } else if (!this.barcodeProductSelection && this.currentProductBrand.trim() != "" && this.currentProductModel.trim() != "") {
        this.productSelection.push({
          productId: -1,
          productType: 2,
          productName: this.currentProductBrand.trim() + " " + this.currentProductModel.trim(),
          barcode: "",
        });
        this.barcodelessDevices.push({
          firstColumn: this.currentProductBrand.trim(),
          secondColumn: this.currentProductModel.trim(),
        });
      }
      this.clearDeviceToSelectionTable();
      this.orderCreatingProperties.barcodelessTable = this.barcodelessDevices;
      let a = this.productSelection.filter((x) => x.productId > -1);
      this.orderCreatingProperties.DbOrderLineType = [];

      for (var i = 0; i < a.length; i++) {
        this.orderCreatingProperties.DbOrderLineType.push({
          productID: a[i].productId,
          productType: 1,
          productAmount: 1,
          discount: 0,
          Price: 0,
          SerialNumber: a[i].barcodeId,
        });
      }
    },
    //barkodlu barkodsuz ekleme işlemi sonrası temizleme
    clearDeviceToSelectionTable() {
      this.currentDeviceBarcode = null;
      this.currentProductBrand = "";
      this.currentProductModel = "";
    },
    //servis için seçilen cihazların listeden silinmesi
    deleteRow(id) {
      if (this.productSelection[id].productType == 2) {
        for (let i = 0; i < this.barcodelessDevices.length; i++) {
          if (this.barcodelessDevices[i].firstColumn.trim() + " " + this.barcodelessDevices[i].secondColumn.trim() == this.productSelection[id].productName) {
            this.barcodelessDevices.splice(i, 1);
            break;
          }
        }
      }
      this.productSelection.splice(id, 1);
    },
    //cihaz ekleme ekranının onaylanarak kapanıs eventleri
    submitDeviceFeatures() {
      this.activeDeviceFeatures = false;
    },
    //cihaz ekleme ekranının iptal edilerek kapanıs eventleri
    cancelDeviceFeatures() {
      this.activeDeviceFeatures = false;
    },
    //servis kaydının vazgeçilerek kapanısı
    clearFields() {
      this.initProp();
      sessionStorage.removeItem("unfinishedTechnicForm");
    },
    cancel() {
      sessionStorage.setItem("unfinishedTechnicForm", JSON.stringify(this.orderCreatingProperties));
      this.$emit("hideAddNewRegister");
    },
    isAllValid: async function() {
      return await this.$validator.validateAll();
    },
    uploadImages: async function() {
      let x = await repository.postFile("Technic/createOrderFile", this.imageList, "_files");
      if (!x || x.hasExceptionError) {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: "Fotoğraf(lar) yüklenirken bir hata oluştu",
        });
        return [];
      } else {
        return x.list;
      }
    },
    //emit fonksiyonun çalışmasını sağlamak için
    postModel: async function(postModel) {
      let images = await this.uploadImages();
      postModel.imageList = JSON.stringify(images);
      let r = await repository.postEntity("Technic/createOrder", postModel);
      if (r.isSuccessful) {
        this.$vs.notify({
          color: "success",
          icon: "done",
          title: "Tamamlandı",
          text: "Ekleme işlemi başarılı!",
        });
        return r;
        //return this.getNewItem(r.returnID);
      } else if (r.hasExceptionError) {
        this.$vs.notify({
          color: "danger",
          title: "İşlem tamamlanamadı!",
          text: r.exceptionMessage,
        });
      } else {
        this.$vs.notify({
          color: "danger",
          title: `Hata`,
          text: "Bilinmeyen bir hata sebebiyle işlem tamamlanamadı!",
        });
      }
      return null;
    },
    getNewItem: async function(_id) {
      let a = await repository.postEntity("technic/getOrders", {
        id: _id,
      });
      if (a.isSuccessful) {
        return a.list[0];
      } else return null;
    },
    //servis kaydının onaylanarak kapanısı
    submitRegistiration: async function() {
      
      let postSuccessful = false;

      if (!this.orderCreatingProperties.customerId || this.orderCreatingProperties.customerId <= 0) {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: "Lütfen müşteri seçtiğinizden emin olunuz!",
        });
        return;
      }

      //cihaz için teknik servis kaydı
      if (!this.garageComes) {
        this.orderCreatingProperties.serviceType = this.currentServiceType.id;
        this.orderCreatingProperties.orderTotal = 0;
        this.orderCreatingProperties.orderdiscount = 0;
        this.orderCreatingProperties.vehicle = {};

        if (this.isAllValid()) {
          let rId = await this.postModel(this.orderCreatingProperties);
          if (!isNaN(parseInt(rId.returnID))) {
            postSuccessful = true;
            let urun = "";
            if (this.barcodeProductSelection) {
              urun = this.orderCreatingProperties.DbOrderLineType[0].product;
            } else {
              urun = this.orderCreatingProperties.barcodelessTable[0].firstColumn + " " + this.orderCreatingProperties.barcodelessTable[0].secondColumn;
            }
            let x = {
              serviceId: rId.returnID,
              customerName: this.selectedCustomer.firstName,
              serviceStatus: "Yeni",
              serviceStatusId: 0,
              updatedDate: "1900-01-01T00:00:01",
              displayTransferProgress: true,
              status: true,
              transferStatus: -1,
              nextStatus:
                "[{'id':1,'value':'Beklemede'},{'id':2,'value':'Onarımda'},{'id':3,'value':'Tahsilat Bekliyor'},{'id':4,'value':'Teslimata Hazır'},{'id':5,'value':'Teslimatta'},{'id':6,'value':'Müşteri Dönüşü Bekleniyor'},{'id':97,'value':'Tamamlandı'},{'id':98,'value':'İade Edilecek'},{'id':99,'value':'İptal'}]",
              createdDate: new Date(),
              serviceType: this.orderCreatingProperties.serviceType == 4 ? "Garaj" : this.currentServiceType.value,
              serviceTypeId: this.orderCreatingProperties.serviceType,
              products: [{ productName: '[{"name":"' + urun + '"}]' }],
              assignedUser: this.$store.state.userData.userName,
            };
            this.$emit("addedData", x);
          }
        }
      }
      //garaj girişli teknik servis kayıt
      else {
        if (this.carModel == "") {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: `Araç seçiniz.`,
          });
        }
        //iki panel doldurulmussa garaj kaydında diğerini boşaltıyorum
        this.orderCreatingProperties.deliveredBy = "";
        this.orderCreatingProperties.DbOrderLineType = [];
        this.orderCreatingProperties.orderTotal = 0;
        this.orderCreatingProperties.barcodelessTable = [];
        this.orderCreatingProperties.orderdiscount = 0;
        let isvalid = await this.isAllValid();
        if (isvalid) {
          let r = await repository.postEntity("Technic/createOrder", this.orderCreatingProperties);
          if (r && r.isSuccessful) {
            postSuccessful = true;
            this.$vs.notify({
              color: "success",
              icon: "done",
              title: "Tamamlandı",
              text: r.returnID + "Ekleme işlemi başarılı!",
              fixed: true,
            });
            //message: "Alfa Romeo 33 undefined"
            repository.postEntity("General/pushNotification", {
              id: -1,
              title: "Sinyal - Yeni araç",
              message: this.brand.value,
              icon: "81",
              time: new Date(),
              category: "4",
              from: "0",
              to: "26", //26,40
              link: '{"name":"techServicePanel","id":"' + r.returnID + '"}',
            });
            repository.postEntity("General/pushNotification", {
              id: -1,
              title: "Sinyal - Yeni araç",
              message: this.brand.value,

              icon: "81",
              time: new Date(),
              category: "4",
              from: "0",
              to: "40", //26,40
              link: '{"name":"techServicePanel","id":"' + r.returnID + '"}',
            });

            let urun = this.orderCreatingProperties.vehicle.plate;
            postSuccessful = true;
            let x = {
              serviceId: r.returnID,
              customerName: this.selectedCustomer.firstName,
              serviceStatus: "Yeni",
              serviceStatusId: 0,
              updatedDate: "1900-01-01T00:00:01",
              displayTransferProgress: false,
              status: true,
              transferStatus: -1,
              nextStatus:
                "[{'id':1,'value':'Beklemede'},{'id':2,'value':'Onarımda'},{'id':3,'value':'Tahsilat Bekliyor'},{'id':4,'value':'Teslimata Hazır'},{'id':5,'value':'Teslimatta'},{'id':6,'value':'Müşteri Dönüşü Bekleniyor'},{'id':97,'value':'Tamamlandı'},{'id':98,'value':'İade Edilecek'},{'id':99,'value':'İptal'}]",
              createdDate: new Date(),
              serviceType: "Garaj",
              serviceTypeId: 4,
              products: [{ productName: '[{"name":"' + urun + '"}]' }],
              assignedUser: this.$store.state.userData.userName,
            };
            this.$emit("addedData", x);
          } else if (r && r.hasExceptionError) {
            this.$vs.notify({
              color: "danger",
              title: "Hata",
              text: `${r.exceptionMessage}`,
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata",
              text: "Bilinmeyen bir sebepten işlem tamamlanamadı!",
            });
          }
        }
      }
      if (postSuccessful) {
        this.clearFields();
        this.$emit("hideAddNewRegister");
      }
    },
    getCustomerProducts: async function() {
      let mId = parseInt(this.orderCreatingProperties.customerId);
      if (isNaN(mId) || mId < 1) {
        return;
      }
      let x = await repository.getAll("Customer/getProductList?id=" + this.orderCreatingProperties.customerId);
      if (x && x.isSuccessful) {
        x = x.list;
        for (let i = 0; i < x.length; i++) {
          x[i].label = x[i].serialNumber ? "[ " + x[i].serialNumber + " ] " + x[i].product : x[i].product;
        }
        this.ownedDevices = x;
      }
    },
    //servis durumları çekilmesi
    getTechnicalServiceTypeList: async function() {
      let x = await repository.getAll("Technic/getTypeList?displayAll=false").then((r) => r.list);
      this.serviceStatus = x;
    },
    //veri tabanından araç marka model jategori çekilmesi
    getVehicleDropDown: async function() {
      let x = await repository.getAll("Technic/getVehicleDropDowns").then((r) => r.entity);
      localStorage.setItem("vehicleDropDowns", JSON.stringify(x));
      this.vehicleDropDowns = x;
    },
    getCustomerById(id) {
      if (id != 0) {
        repository.getById("Customer/getById", id).then((r) => {
          this.selectedCustomer = JSON.parse(JSON.stringify(r.list))[0];

          if (this.selectedCustomer.lastName != null) {
            this.selectedCustomer.firstName = this.selectedCustomer.firstName + " " + this.selectedCustomer.lastName;
          }
        });
      }
    },
    //yarım bırakılan arabanın marka model bulunması
    carFeatureGetter(d) {
      try {
        let a = JSON.parse(localStorage.getItem("vehicleDropDowns"));
        let modelObject = a.models.find((x) => x.id == d);
        this.cat = a.categories.find((x) => x.id == modelObject.categoryId);
        this.brand = a.brands.find((x) => x.id == modelObject.brandId);
      } catch (e) {
        console.warn("carFeatureGetter", e);
      }
    },
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        this.$emit("hideDisplayPrompt", false);
      }
    });
  },
  created() {
    this.initProp();
    this.getTechnicalServiceTypeList();
    this.getVehicleDropDown();
    this.orderCreatingProperties.recordDate = this.getDate;
    let a = sessionStorage["unfinishedTechnicForm"];

    if (repository.isJSON(a)) {
      a = JSON.parse(a);
      let b = this.orderCreatingProperties;
      let bKeys = Object.keys(b);
      let vKeys = Object.keys(b.vehicle);
      let brcdKeys = Object.keys(b.DbOrderLineType);
      let blessKeys = Object.keys(b.barcodelessTable);

      let control = true;

      //elimizdeki veri ile storagaden gelen karşılaşıtrılıyor
      for (let i = 0; i < bKeys.length; i++) {
        if (typeof a[bKeys[i]] == "undefined") {
          control = false;
          this.$vs.notify({
            title: "Uyarı !",
            text: "Yarım kalan kayıt işleminde veri kaybı yaşandı..",
            color: "warning",
            time: 4000,
            icon: "warning",
          });
          break;
        }
      }
      //elimizdeki verinin araç kısmı  ile storagaden gelen karşılaşıtrılıyor
      if (control) {
        for (let i = 0; i < vKeys.length; i++) {
          if (typeof a.vehicle[vKeys[i]] == "undefined") {
            control = false;
            break;
          }
        }
      }
      //elimizdeki verinin araç kısmı  ile storagaden gelen karşılaşıtrılıyor
      if (control) {
        for (let i = 0; i < brcdKeys.length; i++) {
          if (typeof a.DbOrderLineType[brcdKeys[i]] == "undefined") {
            control = false;
            break;
          }
        }
      }
      //elimizdeki verinin araç kısmı  ile storagaden gelen karşılaşıtrılıyor
      if (control) {
        for (let i = 0; i < blessKeys.length; i++) {
          if (typeof a.barcodelessTable[blessKeys[i]] == "undefined") {
            control = false;
            break;
          }
        }
      }
      //elimizdeki veri tarih kısmı ile storagaden gelen karşılaşıtrılıyor
      if (control) {
        for (let i = 0; i < bKeys.length; i++) {
          if (JSON.stringify(a[bKeys[i]]) != JSON.stringify(b[bKeys[i]]) && bKeys[i].toLowerCase().indexOf("date") < 0) {
            control = false;
            break;
          }
        }
        if (control) return;

        let result = false;
        let xxx = () => {
          result = confirm(" Yarım kalan kayıt işlemine devam etmek ister misiniz ?");
        };
        xxx();
        if (result) {
          this.orderCreatingProperties = a;
          let bt = this.orderCreatingProperties.barcodelessTable;
          for (let i = 0; i < bt.length; i++) {
            this.productSelection.push({
              productName: bt[i].firstColumn + bt[i].secondColumn,
            });
          }
          this.getCustomerById(this.orderCreatingProperties.customerId);

          if (this.orderCreatingProperties.serviceType == 4) {
            this.garageComes = true;
            if (this.orderCreatingProperties.vehicle.model != "") this.carFeatureGetter(this.orderCreatingProperties.vehicle.model);
          }
        }
        if (!result) {
          sessionStorage.removeItem("unfinishedTechnicForm");
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.vs-dialog i.vs-dialog-cancel {
  top: 5px !important;
  right: 10px !important;
}
.vs__dropdown-toggle {
  height: 25px !important;
}
.vs__selected {
  height: 15px !important;
}
.vs__search {
  height: 15px !important;
}

.flatpickr-input {
  height: 15px !important;
}
.vs__dropdown-menu {
  max-height: 150px;
}
#heighter {
  .vs-con-table .vs-con-tbody {
    height: 185px;
  }
}
.v-dropdown-container {
  z-index: 9999999 !important ;
  width: 397px;
}
#multipleImage {
  font-family: "Times New Roman", Times, serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 20px;
  width: 100% !important;
}
.image-container {
  width: 100% !important;
}
.errorfonts {
  color: red;
}
</style>
